export const anyDateFormat = /[0-9]{1,2}[-.\/][0-9]{1,2}[-.\/]\d{4}/
export const anyDateFormatWithoutYear = /[0-9]{1,2}[-.\/][0-9]{1,2}/